var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnChatBubbleOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.666 2.66675H5.33268C3.86602 2.66675 2.66602 3.86675 2.66602 5.33341V29.3334L7.99935 24.0001H26.666C28.1327 24.0001 29.3327 22.8001 29.3327 21.3334V5.33341C29.3327 3.86675 28.1327 2.66675 26.666 2.66675ZM26.666 21.3334H7.99935L5.33268 24.0001V5.33341H26.666V21.3334Z",
    fill: "#006A67"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnChatBubbleOutline);
export default __webpack_public_path__ + "static/media/icn-chat_bubble_outline.e4589b9d9bd48bbdb99096e921c6dcd3.svg";
export { ForwardRef as ReactComponent };